import { createI18n } from 'vue-i18n';
import { appSystemInfo } from "@/app.config.js";
import en from './en.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';
import ja from './ja.json';
import ko from './ko.json';
import th from './th.json';
import vi from './vi.json';
import id from './id.json';
import hi from './hi.json';
import tr from './tr.json';
import ar from './ar.json';
import es from './es.json';
import pt from './pt.json';

const locale = uni.getStorageSync('language') || appSystemInfo.lang;

const i18n = createI18n({
  legacy: false,
  locale,
  messages: {
    en,
    "zh-Hant":zhHant,
    "zh-Hans":zhHans,
    ja,
    ko,
    th,
    vi,
    id,
    hi,
    tr,
    ar,
    es,
    pt
  }
});


export default i18n;
